import TermGoodHabits from './list/TermGoodHabits'

export default function HospitalTerms() {
  const terms = [TermGoodHabits()]

  return terms
}
